export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/9efedd6f8d84b8cf11b1862201b47d04.svg";